"use client";
import React from "react";
import SwiperCore from "swiper";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Empty } from "antd";
import { type Blog } from "@/lib/@types/api/blog";

import BlogItemDefault from "@/components/Blogs/BlogItemDefault";

// 初始化 Swiper 模块
SwiperCore.use([Pagination]);

const LatestNews = ({
	blogList,
	title,
	introductionTitle,
	description,
	/** 由服务端 getTranslations 传入（原 t("home.latestnews")），避免客户端降级时无 NextIntlClientProvider */
	defaultTitle = "",
	/** 由服务端 getTranslations 传入，对应原 t("blog.dec") */
	defaultDescription = "",
}: {
	blogList: Blog.BlogListItem[];
	title?: string;
	introductionTitle?: string;
	description?: string;
	defaultTitle?: string;
	defaultDescription?: string;
}) => {
	const heading = introductionTitle
		? `${introductionTitle} ${title ?? defaultTitle}`.trim()
		: title ?? defaultTitle;
	const desc = description ?? defaultDescription;

	return (
		<div className="container">
			<h2 className="mb-3 text-center text-2xl font-bold text-black sm:mb-4 sm:text-[30px] md:text-4xl">
				{heading}
			</h2>
			<p className="mb-4 text-center text-sm leading-relaxed text-black md:text-base">{desc}</p>
			{blogList && blogList.length > 0 ? (
				<Swiper
					spaceBetween={10}
					slidesPerView={1}
					pagination={{ clickable: true }}
					breakpoints={{
						640: {
							slidesPerView: 1,
						},
						768: {
							slidesPerView: 2,
						},
						1024: {
							slidesPerView: 4,
						},
						1600: {
							slidesPerView: 4,
						},
					}}
					className="animate__animated animate__fadeIn !p-4 !pb-14"
				>
					{blogList.map((news) => (
						<SwiperSlide key={news.blog_id}>
							<BlogItemDefault news={news}></BlogItemDefault>
						</SwiperSlide>
					))}
				</Swiper>
			) : (
				<div>
					<Empty />
				</div>
			)}
		</div>
	);
};

export default LatestNews;
